// @flow
import attr from './attr'

export default attr('pk')
